<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-66">
        <edit-profile-form
          data-background-color="green"
          :applicant-id="applicantId"
        >
        </edit-profile-form>
      </div>
    </div>
  </div>
</template>

<script>
import { EditProfileForm } from "@/pages";

export default {
  components: {
    EditProfileForm
  },
  props: {
    applicantId: null
  },
  data() {
    return {
      user: null
    };
  },
  methods: {
    // implement necessary methods.
  },
  created() {
    // implement necessary invocations when component is created.
  }
};
</script>
